import { gql } from '@apollo/client/core';
import { useMutation } from '@vue/apollo-composable';

export function useGetPortaalToegang() {
  type Input = {
    input: {
      gebruikersnaam: string;
    };
  };

  type Response = {
    portaalToegang: {
      portaalToegang: number;
      urlAnderPortaal: string;
    };
  };

  const PORTAAL_TOEGANG = gql`
    query portaalToegangQuery($input: Input) {
      portaalToegang(input: $input)
        @rest(
          method: "POST"
          path: "Login/GetPortaalToegang"
          bodyKey: "input"
        ) {
        portaalToegang
        urlAnderPortaal
      }
    }
  `;

  const { loading: posting, mutate: post } = useMutation<Response, Input>(
    PORTAAL_TOEGANG,
  );

  return { posting, post };
}
